module.exports = __webpack_public_path__ + "static/google-logo-22afc01b435c8b4e5e73040370bf1cb0.png";